import React from "react";
import { ArrowLeft, MessageCircle } from "lucide-react";
import basiqMark from "../assets/basiq-mark.png";
import PlansGrid from "./upgrade/PlansGrid";
import HowItWorksWA from "./upgrade/HowItWorksWA";
import SocialProofBlock from "./upgrade/SocialProofBlock";
import FaqBlock from "./upgrade/FaqBlock";
import { Reveal } from "./upgrade/Bits";

export default function UpgradePage({ onBack }) {
  const toPlans = () => document.getElementById("upgrade-plans-anchor")?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <div className="relative min-h-screen pt-14 overflow-hidden" data-testid="upgrade-page">
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[520px] rounded-full opacity-70 blur-3xl" style={{ background: "radial-gradient(circle at center, #E5E1FA, transparent 70%)" }} />

      <div className="relative max-w-6xl mx-auto px-5 pt-8 pb-24">
        <button onClick={onBack} data-testid="upgrade-back" className="inline-flex items-center gap-1.5 text-[13px] text-slate-500 hover:text-slate-900 transition-colors">
          <ArrowLeft size={15} /> Voltar ao app
        </button>

        <div className="mt-8 text-center max-w-3xl mx-auto float-up">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider bg-white ring-1 ring-slate-200 text-[#4A3BFA]">
            <img src={basiqMark} alt="" className="h-3.5 w-auto" /> Planos Basiq
          </div>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 leading-[1.05]">
            Orçamentos ilimitados, <span className="text-[#4A3BFA]">direto do WhatsApp.</span>
          </h1>
          <p className="mt-5 text-slate-500 text-base md:text-lg">Sem limite de 3 por mês, sem marca Basiq no PDF, com todos os modelos e o assistente no seu WhatsApp. Teste 7 dias grátis.</p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <button onClick={toPlans} data-testid="upgrade-hero-cta" className="cta-upgrade h-12 px-7 rounded-full text-[15px] font-semibold inline-flex items-center gap-2">
              Ver planos e testar grátis
            </button>
            <span className="inline-flex items-center gap-1.5 text-[13px] text-slate-500"><MessageCircle size={15} className="text-[#25D366]" /> WhatsApp incluso a partir do Standard</span>
          </div>
        </div>

        <div id="upgrade-plans-anchor" className="mt-16 scroll-mt-24">
          <PlansGrid />
        </div>

        <HowItWorksWA />
        <SocialProofBlock />
        <FaqBlock />

        <Reveal className="mt-24">
          <div className="rounded-[32px] bg-slate-900 text-white px-8 py-12 sm:px-14 sm:py-16 text-center relative overflow-hidden" data-testid="upgrade-final-cta">
            <div className="pointer-events-none absolute -top-24 -right-24 w-[380px] h-[380px] rounded-full opacity-40 blur-3xl" style={{ background: "radial-gradient(circle, #4A3BFA, transparent 70%)" }} />
            <h2 className="relative text-3xl sm:text-4xl font-bold tracking-tight">Seu próximo orçamento pode sair em 11 segundos.</h2>
            <p className="relative mt-4 text-white/70 text-base md:text-lg">Comece o teste grátis agora. Cancele quando quiser.</p>
            <button onClick={toPlans} data-testid="upgrade-final-btn" className="relative mt-8 cta-upgrade h-12 px-8 rounded-full text-[15px] font-semibold inline-flex items-center gap-2">
              <img src={basiqMark} alt="" className="h-4 w-auto brightness-0 invert" /> Testar 7 dias grátis
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
